import Message from './message.vue'

export default {
	Message,
}



// WEBPACK FOOTER //
// ./src/views/message/index.js